import { render, staticRenderFns } from "./ItemSizeSelector.vue?vue&type=template&id=499e085c&scoped=true"
import script from "./ItemSizeSelector.vue?vue&type=script&lang=js"
export * from "./ItemSizeSelector.vue?vue&type=script&lang=js"
import style0 from "./ItemSizeSelector.vue?vue&type=style&index=0&id=499e085c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499e085c",
  null
  
)

export default component.exports